<template>
    <div class="modal" :class="{'is-active': isOpen}">
        <div class="modal-background" @click="closeModal"></div>
        <div class="modal-content" @keydown.esc="closeModal">
            <div class="container box has-text-centered" role="dialog" aria-labelledby="sideModalTitle">
                <p class="title" id="sideModalTitle" ref="modalTitle" tabindex="0" @keydown.shift.tab.prevent="">{{ title }}</p>
                <figure class="image is-16by9">
                    <iframe class="has-ratio" width="640" height="360" :src="video" frameborder="0" :title="cardInfo.ariaDemo" allowfullscreen></iframe>
                </figure>
                <hr>
                <div class="buttons">
                    <a :href="cardInfo.source" :aria-label="cardInfo.ariaSource" class="button is-fullwidth" target="_blank" rel="noreferrer">View Source</a>
                    <a :href="cardInfo.site" :aria-label="cardInfo.ariaSite" class="button is-fullwidth" target="_blank" rel="noreferrer">Live Version</a>
                </div>
            </div>
        </div>
        <button class="modal-close is-large" id="closeBtn" aria-label="close" @click="closeModal" @keydown.tab.exact.prevent=""></button>
    </div>
</template>

<script>
import sideProjects from '@/models/sideProjects'

export default {
    props: {
        isOpen: Boolean,
        i: Number
    },
    data: () => ({
        sideProjects
    }),
    computed: {
        cardInfo: function() {
            return sideProjects.sideProjects[this.i]
        },
        title: function() {
            return this.cardInfo.title
        },
        video: function() {
            return this.cardInfo.video
        }
    },
    methods: {
        closeModal () {
            this.$emit("close-modal");
        }
    },
    watch: {
        //Set the focus to the opened modal
        isOpen: function () {
            if(this.isOpen == true) {
                this.$nextTick(() => {
                    const newFocus = this.$refs.modalTitle;
                    newFocus.focus();
                })
            }
        }
    }
}
</script>

<style scoped>
    #sideModalTitle:focus {
        outline: none;
    }
    .modal-close:hover {
        background: hsl(0, 0%, 29%);
    }
    .modal-close:focus {
        background: hsl(0, 0%, 29%);
    }
</style>